// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldCheckboxGroup_root__1otIT","list":"FieldCheckboxGroup_list__23njC","twoColumns":"FieldCheckboxGroup_twoColumns__yjtnb","item":"FieldCheckboxGroup_item__3p8qQ"};